import { useTheme } from '@mui/material';
import { DisarmedAlarmIcon } from 'assets/icons/DisarmedAlarmIcon';
import { ArmedAlarmIcon } from 'assets/icons/ArmedAlarmIcon';
import { getAlarmIconColor } from './alerts.logic';

export const AlarmIcon = ({ isArmed }: { isArmed: boolean }) => {
	const theme = useTheme();
	const iconColor = getAlarmIconColor(isArmed, theme);
	return isArmed ? <ArmedAlarmIcon color={iconColor} /> : <DisarmedAlarmIcon color={iconColor} />;
};
